import { render } from "./CampaignsView.vue?vue&type=template&id=0f0d641e&scoped=true&ts=true"
import script from "./CampaignsView.vue?vue&type=script&lang=ts"
export * from "./CampaignsView.vue?vue&type=script&lang=ts"

import "./CampaignsView.vue?vue&type=style&index=0&id=0f0d641e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0d641e"]])

export default __exports__